import { Add } from '@mui/icons-material'
import { Button } from '@mui/material'
import { useEffect, useState } from 'react'
import { EditProps } from './@types'
import { IconPreview } from './icon-preview'

export function Edit({ defaultFile, label, onIconFileChange }: EditProps) {
  const [file, setFile] = useState<File | null>(null)

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { files: newFiles } = event.currentTarget
    if (newFiles && newFiles[0]) {
      setFile(newFiles[0])
    } else {
      setFile(null)
    }
  }

  useEffect(() => {
    onIconFileChange(file)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file])

  return (
    <Button
      color="inherit"
      variant="text"
      className="!overflow-hidden !w-[190px] !h-[174px]"
      sx={{
        position: 'relative',
        border: '1px solid',
        flexDirection: 'column',
        justifyItems: 'center',
        justifyContent: 'space-evenly',
        gap: 6,
        p: 2,
      }}
    >
      {/* Prioriza o arquivo selecionado pelo usuário */}
      {file ? (
        <IconPreview alt="pré-visualização do ícone" file={file} />
      ) : defaultFile ? (
        <IconPreview alt="pré-visualização do ícone" file={defaultFile} />
      ) : (
        <>
          <Add />
          <span className="absolute bottom-4">{label}</span>
        </>
      )}

      <input
        type="file"
        accept=".jpg, .png"
        onChange={onChange}
        className="w-full h-full absolute top-0 left-0 opacity-0 z-50 cursor-pointer"
      />
    </Button>
  )
}
